import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreatePurposeComponent } from './create-purpose.component';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    CreatePurposeComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports:[
    CreatePurposeComponent
  ]
})
export class CreatePurposeModule { }
